import React from 'react';
import { motion } from 'framer-motion';
import { fbq } from '../App';
interface NeonButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'danger';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
  scrollTo?: string;
  href?: string;
}
export function NeonButton({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  className = '',
  scrollTo,
  href,
  onClick,
  ...props
}: NeonButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (href) {
      fbq('track', 'AddToCart', {
        content_name: 'Social Hacker v1.0',
        content_type: 'product',
        value: 9.99,
        currency: 'USD'
      });
      window.open(href, '_blank', 'noopener,noreferrer');
    }
    if (scrollTo) {
      document.getElementById(scrollTo)?.scrollIntoView({
        behavior: 'smooth'
      });
    }
    onClick?.(e);
  };
  const baseClasses = 'relative font-mono font-bold uppercase tracking-wider transition-all duration-300 overflow-hidden group z-10';
  const sizeClasses = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-8 py-4 text-base',
    lg: 'px-10 py-5 text-lg md:text-xl'
  };
  const variantClasses = {
    primary: 'text-cyber-black bg-cyber-neon hover:bg-white shadow-neon hover:shadow-neon-strong border-2 border-cyber-neon',
    secondary: 'text-cyber-purple bg-transparent border-2 border-cyber-purple hover:bg-cyber-purple/10 shadow-neon-purple',
    danger: 'text-white bg-cyber-red/20 border-2 border-cyber-red hover:bg-cyber-red/40 shadow-neon-red'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseClasses} ${sizeClasses[size]} ${variantClasses[variant]} ${widthClass} ${className}`} onClick={handleClick} {...props} data-id="element-383">
      {/* Glitch effect overlay on hover */}
      <span className="absolute inset-0 w-full h-full bg-white/20 -translate-x-full group-hover:animate-[scanline_1s_ease-in-out_infinite] opacity-0 group-hover:opacity-100 mix-blend-overlay pointer-events-none" data-id="element-384"></span>

      <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-385">
        {children}
      </span>
    </motion.button>;
}